import React from 'react';

interface Props {
 peerHash: string;
 name?: string | null;
 email?: string | null;
 profileImage?: string | null;
 onClose: () => void;
}

/**
 * 참여자 / 발신자 클릭 시 띄우는 가벼운 정보 모달.
 * 받은 props 만으로 즉시 렌더 (별도 fetch 없음).
 */
const PeerInfoModal: React.FC<Props> = ({ peerHash, name, email, profileImage, onClose }) => (
 <div
  className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-4"
  onClick={onClose}
 >
  <div className="bg-white max-w-sm w-full p-5 shadow-lg" onClick={e => e.stopPropagation()}>
   {profileImage && (
    <img src={profileImage} alt="" className="w-16 h-16 mx-auto mb-2 object-cover" />
   )}
   <div className="text-center font-semibold text-gray-800">{name || '이름 없음'}</div>
   {email && <div className="text-center text-sm text-gray-500 mt-1">{email}</div>}
   <div className="text-[10px] text-gray-400 break-all mt-3">
    <span className="font-medium">hash:</span> {peerHash}
   </div>
   <button
    onClick={onClose}
    className="mt-4 w-full py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm"
   >닫기</button>
  </div>
 </div>
);

export default PeerInfoModal;
